import { ReloadOutlined, WechatOutlined, AlipayCircleOutlined } from '@ant-design/icons';

import { externalLink } from '@/utils/env';
import i18n from '@/locales/init';

export interface IBuyQrCodeProps {
  qrCode: string;
  currentOrderStatus: number;
  outOfTime: boolean;
  loading: boolean;
  amount: number | string;

  className?: string;

  refresh?: () => void;
}

export const BuyQrCode = ({
  qrCode, currentOrderStatus, outOfTime, loading, className, refresh, amount
}: IBuyQrCodeProps) => {
  return <>
    <div>
      <span className='text-[#F54531] text-[30px] font-bold mx-[2px]'>¥{amount}</span>
      <span className='text-[12px] font-bold'>{i18n.t('元')}</span>
    </div>
    <div className='relative rounded-[12px] border border-[#e5e5e5] p-[10px] my-[20px] w-[156px]'>
      <img src={qrCode} alt=''></img>
      {
        outOfTime ? <div
          className='cursor-pointer absolute w-full h-full left-0 top-0 bg-[#ffffffee] flex flex-col justify-center items-center rounded-[12px]'
          onClick={refresh}>
          <div className="mt-[12px]">
            <ReloadOutlined className="text-[28px]" />
          </div>
          <div className='text-base mt-[12px] text-black/60 text-center'>{i18n.t('点击刷新')}</div>
        </div> : null
      }
      {
        !outOfTime && currentOrderStatus === 2 && <div className='absolute left-0 bottom-[-20px] items-center flex gap-[5px] ml-[20px]'>
          <svg width="12" height="12" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM21.6754 30.3189L14.8114 23.3726L10.2857 27.696C13.5771 29.4686 18.1886 32.7017 22.1383 37.7143C24.9291 32.4686 33.5314 21.7371 37.7143 20.7771C37.0389 18.072 36.6583 12.9943 37.7143 10.2857C29.136 15.9429 21.6754 30.3189 21.6754 30.3189Z" fill="#029B00"/>
          </svg>
          <div className='text-[10px] text-[#00000066] text-center'>{i18n.t('扫码成功, 支付中...')}</div>
        </div>
      }
    </div>
    <div className='w-[156px] mt-[10px] flex'>
      <WechatOutlined className='text-[16px] bg-[#28C445] text-white rounded-full p-[3px] mr-[12px]' />
      <AlipayCircleOutlined className='text-[#06B4FD] bg-[#ffffff] text-[22px]' />
    </div>
    <div className='w-[156px] mt-[10px] text-[12px] text-muted-foreground '>
      <div>{i18n.t('微信或支付宝安全扫码支付')}</div>
      <div className='mt-[10px]'>{i18n.t('支付即代表你同意')}<a className='text-[#1D77FF] underline' target='_blank' href={externalLink.vipAgreement['zh-CN']} rel="noreferrer">{i18n.t('会员协议')}</a></div>
    </div>
  </>;
};
